module.exports = __webpack_public_path__ + "img/plagiarism-free.1957c9c4.svg";